import React from "react";
import QuoteStepBase, { getDriverStepMapDispatch, mapDriverStepProps } from '../components/QuoteStepBase'
import Question from '../components/Question'
import Address from "../components/Address";
import ButtonContinue from "../components/ButtonContinue";
import { IDriverStepProps, IQuoteStepState } from "../components/interfaces";
import { IAddress, IAddressChangeResult } from "../classes/Domain";
import { IAppState } from "../state/interfaces";
import { PATHS, QUOTE_STEPS, YES_NO, COMPONENTS, QUOTE_QUESTIONS } from "../AppConstants";
import { connect } from "react-redux";
import { validationUtils } from "../validation/Validation";
import QuoteStep from "./QuoteStepLayout";
import Utilities from "../classes/Utilities";
import USPSClient from "../classes/USPSClient";

interface IState extends IQuoteStepState {
    residenceYears : string,
    homeOwnership : string,
    homeType : string,
    liveWithParents : string,
    address: IAddress | null,
    invalidAddress: boolean,
    appStateMounted: boolean
}

interface IProps extends IDriverStepProps {
    zipCode: string
}

class YourHome extends QuoteStepBase<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.next = this.next.bind(this);
        this.onAddressChanged = this.onAddressChanged.bind(this);

        this.state = {
            residenceYears : "",
            homeOwnership : "",
            homeType : "",
            liveWithParents : "",
            address: null,
            updatingStore: false,
            errors: null,
            invalidAddress: true,
            appStateMounted:false
         };
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.reportCurrentStep();
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.appStateMounted) return prevState;
        if (nextProps.meta.propsSource === COMPONENTS.PROPS_SOURCES.APP_STORE) {
            const driver = nextProps.driver;
            nextProps.meta.propsSource = "";

            if (null === driver) return prevState;
            let address = driver.address;

            if (!address) {
                const zipCode = !(nextProps.driver.address && nextProps.driver.address.zipCode) ? nextProps.zipCode : nextProps.driver.address.zipCode;
                address = {
                    street: "",
                    city: "",
                    apartment: "",
                    stateCode: "",
                    zipCode
                };
            }

            return {
                ...prevState,
                residenceYears: driver.residenceYears,
                homeOwnership: driver.homeOwnership,
                homeType: driver.homeType,
                liveWithParents: driver.liveWithParents,
                //address: driver.address,
                address,
                appStateMounted: true
            };
        }

        return prevState;
    }

    next(event : React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        this.setState({ updatingStore: true }, () => {
            const updatedDriver = {
                ...this.props.driver,
                residenceYears: this.state.residenceYears,
                homeOwnership: this.state.homeOwnership,
                homeType: this.state.homeType,
                liveWithParents: this.state.liveWithParents,
                address: this.state.address
            };

            this.props.updateAppState({ quoteUid: this.props.quoteUid, driver: updatedDriver })
                .then(() => this.props.history.push(Utilities.formatUrl(PATHS.YOUR_LICENSE, (0 < this.props.driverIndex ? this.props.driverIndex + "" : ""))),
                    () => {
                        this.setState({ ...this.state, updatingStore: false });
                    });
        });
    }

    onAddressChanged(result: IAddressChangeResult) {
        this.setState({
            ...this.state, address: result.address, invalidAddress: !(result.hasOwnProperty("isValid") && result.isValid)
        });
    }

    homeOwnershipCallbackFunction = (childData: string) => {
        this.setState({ ...this.state, homeOwnership: childData, homeType: "", liveWithParents: "" });
    };

    render() {
        return (
            <QuoteStep id={this.props.id}>
                <div className="titleArea"><h5>YOUR HOME</h5></div>

                <Address label="Address"
                    errors={validationUtils.extractErrorsByPrefix(this.state.errors, "address.")}
                    value={this.state.address}
                    zipCodeDisabled={false}
                    onChange={this.onAddressChanged} />

                {
                    //<Question
                    //    name="residenceYears"
                    //    selected={(v) => { this.setStateValue(v, "residenceYears") }}
                    //    selectedValue={this.state.residenceYears}
                    //    error={validationUtils.getValidationErrorFor(this.state.errors, "residenceYears")}
                    //    items={[
                    //        QUOTE_QUESTIONS.YOUR_HOME.RESIDENCE_YEARS.LESS_SIX_MONTH,
                    //        QUOTE_QUESTIONS.YOUR_HOME.RESIDENCE_YEARS.ONE_YEAR,
                    //        QUOTE_QUESTIONS.YOUR_HOME.RESIDENCE_YEARS.TWO_YEAR,
                    //        QUOTE_QUESTIONS.YOUR_HOME.RESIDENCE_YEARS.THREE_YEAR,
                    //        QUOTE_QUESTIONS.YOUR_HOME.RESIDENCE_YEARS.FOUR_YEAR,
                    //        QUOTE_QUESTIONS.YOUR_HOME.RESIDENCE_YEARS.FIVE_YEAR,
                    //        QUOTE_QUESTIONS.YOUR_HOME.RESIDENCE_YEARS.SIX_YEARS,
                    //    ]}
                    //    lable="How long have you lived at this residence?" />

                    //<Question
                    //    name="homeOwnership"
                    //    selectedValue={this.state.homeOwnership}
                    //    error={validationUtils.getValidationErrorFor(this.state.errors, "homeOwnership")}
                    //    selected={this.homeOwnershipCallbackFunction}
                    //    items={[
                    //        QUOTE_QUESTIONS.YOUR_HOME.HOME_OWNERSHIP.OWN,
                    //        QUOTE_QUESTIONS.YOUR_HOME.HOME_OWNERSHIP.RENT,
                    //        QUOTE_QUESTIONS.YOUR_HOME.HOME_OWNERSHIP.OTHER]}
                    //    lable="Do you rent or own your home?" />

                    //<Question
                    //    style={{ display: this.state.homeOwnership === QUOTE_QUESTIONS.YOUR_HOME.HOME_OWNERSHIP.OWN ? '' : 'none' }}
                    //    name="homeType"
                    //    selected={(v) => { this.setStateValue(v, "homeType") }}
                    //    selectedValue={this.state.homeType}
                    //    error={validationUtils.getValidationErrorFor(this.state.errors, "homeType")}
                    //    items={[
                    //        QUOTE_QUESTIONS.YOUR_HOME.HOME_TYPE.SINGLE_FAMILY,
                    //        QUOTE_QUESTIONS.YOUR_HOME.HOME_TYPE.CONDO,
                    //        QUOTE_QUESTIONS.YOUR_HOME.HOME_TYPE.MOBILE_HOME
                    //    ]}
                    //    lable="What type of home do you own?" />

                    //<Question
                    //    style={{ display: this.state.homeOwnership === QUOTE_QUESTIONS.YOUR_HOME.HOME_OWNERSHIP.OTHER ? '' : 'none' }}
                    //    name="liveWithParents"
                    //    selected={(v) => { this.setStateValue(v, "liveWithParents") }}
                    //    selectedValue={this.state.liveWithParents}
                    //    error={validationUtils.getValidationErrorFor(this.state.errors, "liveWithParents")}
                    //    items={[
                    //        QUOTE_QUESTIONS.YES_NO.YES,
                    //        QUOTE_QUESTIONS.YES_NO.NO
                    //    ]}
                    //    lable="Do you live with your parents?" />
                    }

                <div className="btnContainer">
                    <ButtonContinue
                        disabled={this.state.updatingStore || this.state.invalidAddress}
                        showLoading={this.state.updatingStore}
                        onClick={this.next} />
                </div>
            </QuoteStep>
        );
    }
}

let mapProps = (state: IAppState, ownProps: IProps) => {
    const props = mapDriverStepProps(state, ownProps);

    return {
        ...props,
        zipCode: state.zipCode
    };
};

export default connect(mapProps, getDriverStepMapDispatch(QUOTE_STEPS.YOUR_HOME))(YourHome);
